import React from "react";
import ViewsLoading from "theme/views/ViewsLoading";
import loadable from "@loadable/component";

const options = {
    fallback: <ViewsLoading />,
};

export default {
    default: loadable(() => import("./Default"), options),
    frontpage: loadable(() => import("./Default"), options), //no specifics for Frontpage template
    about_us: loadable(() => import("./Default"), options), //no specifics for AboutUs template
    search: loadable(() => import("./SearchPage"), options),
    not_found: loadable(() => import("./NotFound"), options),
    "not-found": loadable(() => import("./NotFound"), options),
};
